module.exports = __webpack_public_path__ + "img/149.ade1cdef.jpg";